import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import SiteMetadata from '../query/siteMetadata'

function SEO({ description, lang, meta, pageTitle, siteImageRelativePath }) {
  const {
    description: site_description,
    name: site_name,
    siteUrl,
  } = SiteMetadata()

  const metaDescription = description || site_description
  const title = pageTitle ? `${pageTitle} | ${site_name}` : site_name
  const siteImageUrl = siteUrl + siteImageRelativePath

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:image',
          content: siteImageUrl,
        },
        {
          property: 'og:url',
          content: siteUrl,
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'twitter:image',
          content: siteImageUrl,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: 'sv',
  meta: [],
  description: '',
  pageTitle: '',
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  pageTitle: PropTypes.string.isRequired,
}

export default SEO
